let currentDevice = '';
import {ebus} from '../vendor/ebus';

export function updateDeviceClass() {
  let newDevice = '';
  let deviceClass = '';
  if (window.matchMedia('(max-width: 960px)').matches) {
    newDevice = 'xs';
  } else {
    newDevice = 'md';
  }
  deviceClass = '' + newDevice;

  let bodyEl = document.getElementsByTagName('BODY')[0];

  let vdevice = 'vdevice-not-xs';
  bodyEl.classList.remove('vdevice-xs', 'vdevice-not-xs');
  if (window.matchMedia('(max-width: 599px)').matches) {
    vdevice = 'vdevice-xs';
    deviceClass = 'xxs';
  }
  bodyEl.classList.add(vdevice);

  ebus.$emit('setDeviceClass', deviceClass);

  if (currentDevice !== newDevice) {
    currentDevice = newDevice;
    console.log('break to: ' + currentDevice);
    bodyEl.classList.remove('device-xs', 'device-md');
    bodyEl.classList.add('device-' + newDevice);
    ebus.$emit('deviceClassesUpdated');
  }
}

export function getCurrentDevice() {
  return currentDevice;
}

window.addEventListener('resize', () => {
  updateDeviceClass();
});
